import React, { useState } from 'react';
import { string, func } from 'prop-types';

import icon from '../../../../assets/icon-search.svg';
import closeIcon from '../../../../assets/icon-close.svg';
import {
  SearchBarContainer, SearchIcon, SearchBar, ClearIcon, TooltipButtonContainer,
} from './tracking-queue-search-bar.style';
import InfoTooltipButton from '../info-tooltip-button/info-tooltip-button';
import { TOOLTIP_MESSAGES } from '../../../../constants';

/**
 * Tracking queue search bar component
 * @param {object} params - Object containing props
 * @param {string} params.currentSearchTerm - Search term supplied to input initially
 * @param {func} params.searchTermChanged - Func prop to call when a search term is submitted.
 * @return {element}
 */
const TrackingQueueSearchBar = ({ currentSearchTerm, searchTermChanged }) => {
  // State hook
  const [searchTerm, setSearchTerm] = useState(currentSearchTerm);

  /**
   * Handles when a user changes the search term
   * only sets local state
   * @param {object} event - On change event
   * @return {void}
   */
  const handleSearchTermChanged = (event) => {
    setSearchTerm(event.target.value);
  };

  /**
   * Handles when a user submits a search term.
   * @return {void}
   */
  const handleSearchButtonPressed = () => {
    searchTermChanged(searchTerm);
  };

  /**
   * Function to handle clearing the search bar
   * @return {void}
   */
  const clearSearch = () => {
    setSearchTerm('');
    searchTermChanged('');
  };

  /**
   * Handles when a user presses a key in the search box.
   * @param {object} event - Event object
   * @return {void}
   */
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearchButtonPressed();
    }
  };

  return (
    <SearchBarContainer data-testid="tracking-queue-search-bar">
      <TooltipButtonContainer>
        <InfoTooltipButton text={TOOLTIP_MESSAGES['search-bar']} position="bottom" />
      </TooltipButtonContainer>
      <SearchIcon src={icon} onClick={handleSearchButtonPressed} />
      <SearchBar
        placeholder="Search across all loads"
        onChange={handleSearchTermChanged}
        onKeyPress={handleKeyPress}
        data-testid="search-box"
        value={searchTerm}
      />
      {(searchTerm && searchTerm.length > 0)
        && <ClearIcon src={closeIcon} onClick={clearSearch} />}
    </SearchBarContainer>
  );
};

TrackingQueueSearchBar.propTypes = {
  currentSearchTerm: string,
  searchTermChanged: func,
};

TrackingQueueSearchBar.defaultProps = {
  currentSearchTerm: '',
  searchTermChanged: () => { },
};

export default TrackingQueueSearchBar;
